import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import icon from './data/index';
export default {
  components: {
    'd2-icon-cell': function d2IconCell() {
      return import('./components/d2-icon-cell');
    }
  },
  data: function data() {
    return {
      icon: icon,
      showIndex: 12
    };
  },
  computed: {
    iconShow: function iconShow() {
      return this.icon[this.showIndex];
    },
    radioOptions: function radioOptions() {
      return this.icon.map(function (e, index) {
        return {
          label: e.title,
          value: index
        };
      });
    }
  }
};